export default __webpack_public_path__ + "static/media/hexdc.046384fb.svg";